module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "audio-panel",
    attrs: {
      "id": "AUDIOPANEL-SWF"
    }
  }, [_c('div', {
    staticClass: "audio-tabs"
  }, _vm._l((_vm.tabs), function(item, index) {
    return _c('div', {
      class: {
        'active': item.active
      },
      on: {
        "click": function($event) {
          return _vm.handleTabsChange(index, _vm.tabs)
        }
      }
    }, [_vm._v("\n      " + _vm._s(item.name) + "\n    ")])
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabs_status == 0),
      expression: "tabs_status == 0"
    }]
  }, [_c('record')], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabs_status == 1),
      expression: "tabs_status == 1"
    }]
  }, [_c('bgm')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e7a701c6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AudioPanel/AudioPanel.vue
// module id = 404
// module chunks = 0